import "./DataGridsLayout.scss";
//COMPONENTS
import GestDataGrid from '@shared/library/dist/components/gest/GestDataGrid/GestDataGrid';
//MODELS
import { GridValidRowModel } from '@mui/x-data-grid';
import { GestCard } from "@shared/library";
import { IGestDataGridProps } from "@shared/library/dist/components/gest/GestDataGrid/GestDataGridProps";
import { Property } from 'csstype';
import { ISummary } from "../../models/components/components";

interface IDataGridsLayoutProps<T extends GridValidRowModel> {
    area?: ISummary<T>;
    layout?: Property.GridTemplate;
    gridProps?: IGestDataGridProps<T>;
}

const DataGridsLayout = <T extends GridValidRowModel>(props: IDataGridsLayoutProps<T>) =>
    <div id='dataGridsLayout' style={{ gridTemplate: props.layout }}>
        {props.area?.content?.Tabs
            ?.filter(t => t.InitRows.length)
            .map(t =>
                <GestCard
                    key={`card-${t.TabName}`}
                    title={t.TabName || props.area!.label}
                    actions={props.area!.content!.actions}
                    style={{ overflow: "auto" }}
                >
                    <GestDataGrid
                        {...props.gridProps}
                        columns={props.area!.content!.Columns ?? []}
                        rows={t.InitRows}
                        w="calc(100vw - 93px)"
                        autoPageSize={false}
                    />
                </GestCard>)}
    </div>;
export default DataGridsLayout;